import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ReportsChartMain from '../../smart/reportsComponents/ReportsChartMain';
import ReportsContainer from '../../smart/reportsComponents/ReportsContainer';
import CustomReports from '../../smart/reportsComponents/CustomReports';
import ReportBreadcrumbBar from '../../smart/reportsComponents/ReportBreadcrumbBar';
import '../../../../../../node_modules/react-bootstrap-table/css/react-bootstrap-table.css'
import GreyHeader from '../../GreyHeader'
import CustomButton from '../../CustomButton';
import MainTabs from '../../../component/dump/MainTabs';

const Reports = (props) => {
	const navigate = useNavigate();
	const { t } = useTranslation('translation', { keyPrefix: 'components.reports' });
	const { t: tPages } = useTranslation('translation', { keyPrefix: 'constants.pages' });
	const { user } = props
	const userRole = user.roles[0]

	const [location, setLocation] = useState(null);
	const [tabKey, setTabKey] = useState(1);
	const [showReport, setShowReport] = useState(false);
	const [selectedReport, setSelectedReport] = useState({});

	useEffect(() => {
		const { location } = props;

		let locationNew = null;
		// ToDo: Refactoring/Check. Looks like device_audit_log doesn't exist. Do we need this if?
		if (location && location.state && location.state.type === 'device_audit_log') {
			locationNew = {
				type: location.state.type,
				device_id: location.state.device_id
			}

			setTabKey(4);
			setLocation(locationNew);
			navigate('/reports', {
				state: {},
				replace: true,
			});
		}
	}, [])

	const handleNavigation = (tabKey, report = null) => {
		if (report) {
			setSelectedReport(report)
		}
		else {
			setShowReport(false)
			setSelectedReport({})
		}
		setTabKey(tabKey)
	}

	const handleShowReport = () => {
		setShowReport(true)
	}

	const mainTabs = (
		<MainTabs>
			<CustomButton variant='tab' active={tabKey === 1} onClick={() => handleNavigation(1)}>
				{t('btnStandard')}
			</CustomButton>
			<CustomButton variant='tab' active={tabKey === 2} onClick={() => handleNavigation(2)}>
				{t('btnCustom')}
			</CustomButton>
			<CustomButton variant='tab' active={tabKey === 3} onClick={() => handleNavigation(3)}>
				{t('btnCharts')}
			</CustomButton>
		</MainTabs>
	)

	return (
		<>
			<GreyHeader
				title='Reports'
				hideTitle
			/>

			{!showReport && <ReportBreadcrumbBar crumbs={[tPages('titleReports')]} />}
			{!showReport && mainTabs}

			{tabKey === 1 && <ReportsContainer handleNavigation={handleNavigation} handleShowReport={handleShowReport} showReport={showReport} selectedReport={selectedReport} mainTabs={mainTabs} />}
			{tabKey === 2 && <CustomReports handleNavigation={handleNavigation} handleShowReport={handleShowReport} showReport={showReport} selectedReport={selectedReport} mainTabs={mainTabs} />}
			{tabKey === 3 && <ReportsChartMain />}
		</>
	)
}

Reports.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapStateToProps = ({ user }) => ({
	user: user.user
});

export default connect(mapStateToProps)(Reports);
